export default {"src":"/_next/static/media/split.f64cf0de.svg","height":19,"width":70,"blurWidth":0,"blurHeight":0};